import ExperienceCard from "../components/ExperienceCard"

const Main = () => {
    return (
        <div className="w-full px-8 md:px-12 lg:px-16 pt-24 md:pt-28 relative">
            <ExperienceCard />
        </div>
    )
}

export default Main